module.exports = __webpack_public_path__ + "static/media/siprc_dot1.be72922c.png";